import { createSelector } from '@reduxjs/toolkit';

// First select the relevant part from the state
export const selectLoaderState = (state) => state.loader;
export const selectLoaderData = createSelector(selectLoaderState, (state) => state.loading);
export const selectIsLoading = createSelector(
    [selectLoaderState],
    (state) => state.loading
);
